export default __webpack_public_path__ + "static/media/4.abfed3e7.png";